// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from 'react';

const QuestionCircle: React.FC<{ width?: number, height?: number, color1?: string, className?: string }> = ({ width = undefined, height = undefined, color1 = '#577538', className }) => {
    return <svg className={className} focusable="false" width="12" height="13">
        <path fill={color1} d="M11.25 6.5a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0M0 6.5a6 6 0 1 1 12 0 6 6 0 0 1-12 0m3.954-2.02c.152-.577.673-.98 1.27-.98h1.338c.833 0 1.5.68 1.5 1.507 0 .563-.314 1.083-.817 1.34l-.87.441v.462A.376.376 0 0 1 6 7.625a.376.376 0 0 1-.375-.375v-.691c0-.141.08-.27.204-.336l1.073-.548a.76.76 0 0 0 .41-.673.755.755 0 0 0-.75-.757H5.225a.56.56 0 0 0-.544.42l-.004.016a.374.374 0 1 1-.724-.19l.004-.016zm1.483 4.27a.563.563 0 1 1 1.126 0 .563.563 0 0 1-1.125 0"/>
    </svg>;
};

export default React.memo(QuestionCircle);
